/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import SidebarService, { StaticSidebarId } from 'cio/services/sidebar';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { registerDestructor } from '@ember/destroyable';

interface Args {
  highlight: boolean;
  highlightColor?: string;
  name: string;
  image: string;
  description: string;
  cta: string;
  selected: boolean;
  type?: string;
  disabled: boolean;
  disabledTooltip?: string;
  openSidebarOnMountEmpty?: boolean;
  onSidebarClose?: (sidebarWasVisible: boolean) => unknown;
}

export default class ConditionBlockItem extends Component<Args> {
  @service sidebar!: SidebarService;
  @tracked sidebarVisible = false;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    if (args.openSidebarOnMountEmpty === true) {
      /** The setTimeout avoids "You attempted to update (...) but it had already
       * been used previously in the same computation" error */
      setTimeout(() => {
        this.toggleSidebar();
      }, 1);
    }
    registerDestructor(this, () => {
      if (this.sidebar.isOpen) {
        this.sidebar.toggle(StaticSidebarId.CampaignTrigger);
      }
    });
  }

  @action
  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
    // If the sidebar already happens to be open, it will just change its content,
    // so no need for toggling. Same if it already happens to be closed
    if (this.sidebar.isOpen !== this.sidebarVisible) {
      this.sidebar.toggle(StaticSidebarId.CampaignTrigger);
    }
    if (!this.sidebarVisible) {
      // execute onclose callback only if sidebar was closed
      this.args.onSidebarClose?.(true);
    }
  }

  @action
  handleSidebarClose() {
    if (!this.sidebar.isOpen) {
      if (this.sidebarVisible) {
        // execute onclose callback only if it was opened before
        this.args.onSidebarClose?.(true);
      }
      this.sidebarVisible = false;
    }
  }
}
